module.exports = __webpack_public_path__ + "static/img/top-bg.55fe239d.png";